import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'any'
})
export class HeaderService {
    constructor() { }
    private subject = new Subject<any>();

    updateHeaderStates(headerStates: { [key: string]: boolean }) {
        this.subject.next(headerStates);
    }

    headerStates$(): Observable<any> {
        return this.subject.asObservable();
    }
}
